var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 13,
    viewBox: "0 0 25 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08262 1.5V0.5H24.72V1.5V2.5H1.08262V1.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08262 11.5C1.08262 10.9477 0.266722 10.5 1.08262 10.5H24.72V11.5V12.5H1.08262C0.266722 12.5 1.08262 12.0523 1.08262 11.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/Menu__icon.a8fa8a19037762a47730c93f7e57e7d0.svg";
export { ForwardRef as ReactComponent };